import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryCards from './components/CategoryCards';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "Vigorbuy Spreadsheet",
      "url": siteUrl,
      "description": "The ultimate product research database. Discover the latest Vigorbuy Spreadsheet collections, product guides, category comparisons and shopping resources.",
      "inLanguage": "en",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${siteUrl}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "Organization",
      "name": "Vigorbuy Spreadsheet",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg",
      "sameAs": [
        "https://kaspreadsheet.com"
      ],
      "description": "Helping shoppers discover, compare and understand products through organized spreadsheets, guides and research."
    }
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <main>
        <Navbar />
        <Hero />
        <CategoryDropdown />
        <CategoryCards />
        <AboutSection />
        <ComparisonSection />
        <SafetySection />
        <ArticlePreview />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}